// component for displaying a info/mesage

import React, { FC } from 'react';
import TwDialog from '../TwDialog/TwDialog';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';

interface TwInfoModalProps {
  open: boolean;
  title: string;
  body: React.ReactNode;
  onClickClose: () => void;
}

const TwInfoModal: FC<TwInfoModalProps> = ({ open, title, body, onClickClose }): JSX.Element => {
  return (
    <TwDialog
      open={open}
      title={title}
      onClickClose={onClickClose}
      actions={[
        <TwButton
          key="2"
          fullwidth={false}
          type={TwButtonType.primary}
          label="Got it"
          action={onClickClose}
        />
      ]}
    >
      {body}
    </TwDialog>
  );
};

export default TwInfoModal;
